<template>
  <v-container>
    <CampId :urlRequest="urlRequest" :name="name" />
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      urlRequest: "reports/teams",
      name: "Teams Report"
    };
  },
  components: {
    CampId: () => import("../components/CampId")
  }
};
</script>
